import cx from "classnames";

import { File, Trash } from "components/icons/generated";
import ButtonIcon from "ds/components/ButtonIcon";
import Icon from "ds/components/Icon";
import LoadingIndicator from "ds/components/LoadingIndicator";
import TextEllipsis from "ds/components/TextEllipsis";
import Typography from "ds/components/Typography";

import Box from "../../Box";
import styles from "./styles.module.css";

type FileUploadFileItemProps = {
  fileName: string;
  className?: string;
  loading?: boolean;
  onDelete: () => void;
};

const FileUploadFileItem = ({
  fileName,
  className,
  loading,
  onDelete,
}: FileUploadFileItemProps) => (
  <Box
    direction="row"
    justify="between"
    align="center"
    gap="large"
    className={cx(styles.fileItem, className)}
  >
    <Box direction="row" align="center" gap="medium">
      <Icon src={File} noShrink />
      <TextEllipsis tooltip={fileName}>
        {(props) => (
          <Typography {...props} tag="span">
            {fileName}
          </Typography>
        )}
      </TextEllipsis>
    </Box>
    <LoadingIndicator size="large" loading={loading}>
      <ButtonIcon icon={Trash} variant="ghostDanger" onPress={onDelete}>
        Delete
      </ButtonIcon>
    </LoadingIndicator>
  </Box>
);

FileUploadFileItem.displayName = "DS.FileUpload.FileItem";

export default FileUploadFileItem;
